const CategoriaTrabalhadorEnum = Object.freeze({
    APRENDIZ: '103',
    ESTAGIARIO: '901',
    BOLSISTA: '903'
});

export default CategoriaTrabalhadorEnum;
